import { Icon, IconDefinitions } from "../../../../components";

interface SessionEndedBannerProps {
  isFailed: boolean;
}

export function SessionEndedBanner({ isFailed }: SessionEndedBannerProps) {
  return (
    <div
      className="w-100 mb-2 mb-2 px-3 py-2 rounded-2 d-flex align-items-center gap-2"
      style={{
        backgroundColor: isFailed
          ? "rgba(192, 57, 43, 0.08)"
          : "rgba(108, 117, 125, 0.08)",
        border: `1px solid ${isFailed ? "rgba(192, 57, 43, 0.2)" : "rgba(108, 117, 125, 0.2)"}`,
      }}
    >
      <Icon
        iconName={isFailed ? IconDefinitions.warning : IconDefinitions.clock}
        style={{
          color: isFailed ? "#c0392b" : "#6c757d",
          fontSize: "1rem",
        }}
      />
      <small
        className={`fw-semibold ${isFailed ? "" : "text-muted"}`}
        style={isFailed ? { color: "#c0392b" } : undefined}
      >
        {isFailed ? "Session failed" : "Session has ended"}
      </small>
    </div>
  );
}